//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// autopilot-status-unstarted imports
import { IProps, IState } from "./AutopilotStatusRunning.d";
import { styles } from "./AutopilotStatusRunning.styles";
// material-ui
import { Assistant } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";
import { CardIcon } from "@clockwise/web-commons/src/ui/card";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

//////////////////
// COMPONENT
//////////////////
class AutopilotStatusRunningCmpt extends React.Component<IProps, IState> {
  public static defaultProps = {
    isActionable: true,
  };

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <CardIcon
        className={this.props.classes.container}
        onClick={this.props.onClick}
        Icon={Assistant}
        iconProps={{
          htmlColor: greys.white,
        }}
      >
        <div className={this.props.classes.status}>Searching for better times...</div>
        <div className={this.props.classes.description}>This may take a few minutes</div>
      </CardIcon>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const AutopilotStatusRunning = withStyles(styles)(AutopilotStatusRunningCmpt);
